// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"138":"001c3749","194":"d379ca4b","236":"acc51af6","534":"cdb3e086"}[chunkId] + ".css";
};